import api from '../../services/service_expend'
import Swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
import CateView from '../../components/cate_view'
import SubcateView from '../../components/subcate_view'
import moment from 'moment'
import vuejsDatepicker from 'vuejs-datepicker'
import { th } from 'vuejs-datepicker/dist/locale'

export default {
  components: {
    Multiselect,
    CateView,
    SubcateView,
    vuejsDatepicker
  },
  data () {
    return {
      now_date: this.dateFormatDMY2(new Date()),
      cate_exp_list: [],
      sub_cate_exp_list: [],
      expense_sub: [],
      header: {
        headers: {
          'access-token': this.$store.state.token
        }
      },
      cate_exp: 0,
      map_category_expense_date: '',
      map_category_expense_id: 0,
      sub_cate_exp: 0,
      map_amount: 0,
      mode: 0,
      docno: '',
      description: '',
      withdrawal: '',
      expense_sub_index: 0,
      action: 0,
      expense_type: 1,
      th: th
    }
  },
  methods: {
    showModal (mode) {
      this.mode = mode
      $('#editChoice').modal('show')
    },
    editSub (index, value) {
      this.getCate()
      this.action = 1
      this.map_category_expense_id = value.map_category_expense_id
      this.expense_sub_index = index
      this.cate_exp = { cate_exp_id: value.cate_exp_id, cate_exp_name: value.cate_exp_name }
      this.map_category_expense_date = this.dateFormatDMY2(value.map_category_expense_date)
      this.sub_cate_exp = { sub_cate_exp_id: value.sub_cate_exp_id, sub_cate_expense_name: value.sub_cate_expense_name }
      this.map_amount = value.map_amount
      this.description = value.description
      $('#addList').modal('show')
    },
    updateSub () {
      var obj = {
        'map_category_expense_id': this.map_category_expense_id,
        'expense_id': this.$route.params.id,
        'cate_exp_id': this.cate_exp.cate_exp_id,
        'cate_exp_name': this.cate_exp.cate_exp_name,
        'sub_cate_expense_id': this.sub_cate_exp.sub_cate_exp_id,
        'sub_cate_expense_name': this.sub_cate_exp.sub_cate_expense_name,
        'map_amount': this.map_amount,
        'map_category_expense_date': this.map_category_expense_date,
        'description': this.description
      }
      if (this.map_category_expense_id > 0) {
        this.$store.state.isLoading = true
        api.updateSubExpen(
          obj,
          this.header,
          result => {
            if (result.response === true) {
              this.action = 0
              this.map_category_expense_id = 0
              this.cate_exp = 0
              this.sub_cate_exp = 0
              this.map_amount = 0
              this.mode = 0
              this.description = ''
              $('#addList').modal('hide')
            } else {
              Swal.fire('อัพเดทรายละเอียดรายจ่าย', result.message, 'warning')
            }
            this.$store.state.isLoading = false
          },
          error => {
            alert(JSON.stringify(error))
            this.$store.state.isLoading = false
          }
        )
      } else {
        this.expense_sub[this.expense_sub_index]['cate_exp'] = this.cate_exp
        this.expense_sub[this.expense_sub_index]['sub_cate_exp'] = this.sub_cate_exp
        this.expense_sub[this.expense_sub_index]['map_category_expense_date'] = this.map_category_expense_date
        this.expense_sub[this.expense_sub_index]['map_amount'] = this.map_amount
        this.expense_sub[this.expense_sub_index]['description'] = this.description
        this.action = 0
        this.cate_exp = 0
        this.map_category_expense_id = 0
        this.sub_cate_exp = 0
        this.map_amount = 0
        this.mode = 0
        this.description = ''
        $('#addList').modal('hide')
      }
    },
    addSub () {
      this.action = 0
      this.cate_exp = 0
      this.sub_cate_exp = 0
      this.map_category_expense_date = this.dateFormatDMY2(new Date())
      this.map_amount = 0
      this.mode = 0
      this.description = ''
      this.getCate()
      $('#addList').modal('show')
    },
    getExpen (id) {
      this.$store.state.isLoading = true
      api.getExpen(
        id,
        this.header,
        result => {
          if (result.response === true) {
            var exp = result.data
            this.docno = exp.expense_docno
            this.now_date = this.dateFormatDMY2(exp.expense_date)
            this.withdrawal = exp.withdrawal
            this.expense_type = parseInt(exp.expense_type)
            this.expense_sub = exp.expense_sub
            this.expense_sub.forEach(val => {
              this.map_category_expense_date = this.dateFormatDMY2(val['map_category_expense_date'])
            })
          } else {
            Swal.fire('ดึงข้อมูลเอกสารค่าใช้จ่าย', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    getCate () {
      this.$store.state.isLoading = true
      var body = {
        search: '',
        active_page: 1,
        per_page: 10000000000000
      }
      api.getCate(
        body,
        this.header,
        result => {
          if (result.response === true) {
            this.cate_exp_list = []
            result.data.forEach(val => {
              this.cate_exp_list.push({
                'cate_exp_id': val['cate_exp_id'],
                'cate_exp_name': val['cate_exp_name']
              })
            })
            if (this.cate_exp === 0) {
              this.cate_exp = this.cate_exp_list[0]
            }
            this.getSubcate(this.cate_exp)
          } else {
            Swal.fire('ดึงข้อมูลหมวดหมู่', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    getSubcate (value) {
      setTimeout(() => {
        api.getSub(
          value.cate_exp_id,
          this.header,
          result => {
            if (result.response === true) {
              if (result.data.sub_menu) {
                this.sub_cate_exp_list = []
                result.data.sub_menu.forEach(val => {
                  this.sub_cate_exp_list.push({
                    'sub_cate_expense_id': val['sub_cate_expense_id'],
                    'sub_cate_expense_name': val['sub_cate_expense_name']
                  })
                })
                if (this.sub_cate_exp === 0) {
                  this.sub_cate_exp = this.sub_cate_exp_list[0]
                }
              } else {
                this.sub_cate_exp_list = []
              }
            } else {
              Swal.fire('ดึงข้อมูลค่าใช้จ่าย', result.message, 'warning')
            }
          },
          error => {
            alert(JSON.stringify(error))
          }
        )
      }, 500)
    },
    setSubvalue () {
      if (this.sub_cate_exp !== 0 && this.cate_exp !== 0 && this.map_amount > 0) {
        this.expense_sub.push({
          cate_exp_id: this.cate_exp.cate_exp_id,
          cate_exp_name: this.cate_exp.cate_exp_name,
          sub_cate_expense_id: this.sub_cate_exp.sub_cate_expense_id,
          sub_cate_expense_name: this.sub_cate_exp.sub_cate_expense_name,
          map_amount: this.map_amount,
          map_category_expense_date: this.dateFormatDMY2(this.map_category_expense_date),
          description: this.description
        })
        this.cate_exp = 0
        this.sub_cate_exp = 0
        this.map_amount = 0
        this.discription = ''
        this.getCate()
        $('#addList').modal('hide')
      }
    },
    removeSub (index) {
      this.expense_sub.splice(index, 1)
    },
    save () {
      if (this.$route.params.id) {
        if (this.withdrawal !== '') {
          this.$store.state.isLoading = true
          const obj = {
            'expense_id': this.$route.params.id,
            'expense_docno': this.docno,
            'expense_date': this.dateFormatDMY2(this.now_date),
            'withdrawal': this.withdrawal,
            'description': '',
            'expense_type': this.expense_type,
            'expense_sub': this.expense_sub
          }

          api.updateExpen(
            obj,
            this.header,
            result => {
              if (result.response === true) {
                Swal.fire('บันทึกข้อมูลค่าใช้จ่าย', result.data, 'success')
                this.$router.push('/manageexp')
              } else {
                Swal.fire('บันทึกข้อมูลค่าใช้จ่าย', result.message, 'warning')
              }
              this.$store.state.isLoading = false
            },
            error => {
              alert(JSON.stringify(error))
              this.$store.state.isLoading = false
            }
          )
        } else {
          Swal.fire('บันทึกข้อมูลค่าใช้จ่าย', 'กรุณากรอกข้อมูลผู้เบิก', 'warning')
        }
      } else {
        if (this.withdrawal !== '') {
          this.$store.state.isLoading = true
          const obj = {
            'expense_date': this.dateFormatDMY2(this.now_date),
            'withdrawal': this.withdrawal,
            'description': '',
            'expense_type': this.expense_type,
            'expense_sub': this.expense_sub
          }

          api.addExpen(
            obj,
            this.header,
            result => {
              if (result.response === true) {
                Swal.fire('บันทึกข้อมูลค่าใช้จ่าย', result.data, 'success')
                this.$router.push('/manageexp')
              } else {
                Swal.fire('บันทึกข้อมูลค่าใช้จ่าย', result.message, 'warning')
              }
              this.$store.state.isLoading = false
            },
            error => {
              alert(JSON.stringify(error))
              this.$store.state.isLoading = false
            }
          )
        } else {
          Swal.fire('บันทึกข้อมูลค่าใช้จ่าย', 'กรุณากรอกข้อมูลผู้เบิก', 'warning')
        }
      }
    }
  },
  mounted () {
    this.getCate()
    if (this.$route.params.id) {
      this.getExpen(this.$route.params.id)
    }
    // eslint-disable-next-line no-undef
    $('#editChoice').on('hidden.bs.modal', (e) => {
      this.cate_exp = 0
      this.sub_cate_exp = 0
      this.map_amount = 0
      this.getCate()
    })

    $('input').on('change', function () {
      this.setAttribute(
        'data-date',
        // eslint-disable-next-line no-undef
        moment(this.value, 'YYYY-MM-DD')
          .format(this.getAttribute('data-date-format'))
      )
    }).trigger('change')
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/expenditure.js